import React from 'react';
import { useSelector } from 'react-redux';
import { MonthlyData } from 'helper/flux/automatic';
import {
  selectFluxAutomaticControlPanelMltOption,
} from 'redux/reducers/fluxAutomaticControlPanelReducer';
import FluxAutomaticGeneralTable from '../../../GeneralTable';

export default function Table({ data, stickyRowLabel = false }: {
  data: MonthlyData | undefined,
  stickyRowLabel?: boolean,
}) {
  const unidade = useSelector(selectFluxAutomaticControlPanelMltOption);

  return (
    <div className="overflow-auto" style={{ maxHeight: '650px' }}>
      <FluxAutomaticGeneralTable
        data={data}
        tableLabel=""
        percentView={unidade === '%mlt'}
        stickyRowLabel={stickyRowLabel}
      />
    </div>
  );
}
